import { Col, Modal, Rate, Row, Space, Tag, Typography } from "antd"
import React from "react"
import ResumeFeedback from "./ResumeFeedback";

const CandidateResponse = ({ selectedURL, setSelectedURL }) => {

    return <Modal
        open={selectedURL}
        title={selectedURL?.name}
        onCancel={() => setSelectedURL(null)}
        footer={null}
        width={'60%'}
    >
        <ResumeFeedback selectedURL={selectedURL} />
    </Modal>

}

export default CandidateResponse